import { useEffect } from 'react';
import {useDispatch, useSelector} from '../hooks';
import analytics from 'shared/utility/analytics';
import {Heading, LabelText} from 'shared/components';
import {SelectInput} from 'shared/inputs';
import {InputsContainer} from 'shared/containers';
import {sync, SYNC} from 'shared/wizard/actions';

const EnergyLabelForm = () => {
  const dispatch = useDispatch();
  const {
    input: {
      new_regulations,
      energy_label,
    },
    output: {errors},
    meta: {energy_labels, energy_labels_next_year},
  } = useSelector(state => state);

  useEffect(() => {
    dispatch({type: SYNC, syncing: false});
    analytics.send('Navigeer', 'Energie label');
  }, []);

  return (
    <>
      <Heading>Energielabel</Heading>
      <InputsContainer>
        <LabelText>Welk energielabel verwacht je dat je aan te kopen woning zal hebben?</LabelText>
        <SelectInput
          options={new_regulations ? energy_labels_next_year : energy_labels}
          value={energy_label}
          onChange={e => sync(dispatch)('energy_label', e.value)}
          placeholder="Energielabel"
          errors={Boolean(errors?.energy_label)}
        />
      </InputsContainer>
    </>
  );
};

export default EnergyLabelForm;
